module.exports = __webpack_public_path__ + "static/img/pic_phone_1.e82f0fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/pic_phone_1.png
// module id = x6XZ
// module chunks = 1